import request from '@/utils/request'

export function getFinancialList(searchData) {
  return request({
    url: '/expense/getexpenselist',
    method: 'get',
    params:searchData
  })
}

export function uploadFinancialList(data) {
  return request({
    url: '/expense/uploadexpenselist',
    method: 'post',
    data
  })
}

export function getExpenseStatementList(data) {
  return request({
    url: '/expense/getexpensestatementlist',
    method: 'get',
    params:data
  })
}

export function newExpenseStatement(data) {
  return request({
    url: '/expense/newexpensestatement',
    method: 'post',
    data
  })
}
